module.exports = __webpack_public_path__ + "static/img/f_first_05.aa40b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/f_first_05.png
// module id = veSK
// module chunks = 9